import { DashboardSlug, ViewableReports } from '../types/reports.types'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useMemo } from 'react'

interface UseCanViewReportReturn {
  viewableReports: Partial<ViewableReports>
  canViewAnyReports: boolean
  canViewReport: (reportSlug?: string | string[]) => boolean
}

export function useCanViewReport(): UseCanViewReportReturn {
  const { hasOperation } = useAuthState()

  const viewableReports: Partial<ViewableReports> = useMemo(
    () => ({
      [DashboardSlug.FLOWCODE_ANALYSIS]:
        hasOperation('view:flowcode_analysis') || hasOperation('view:flowcode_analysis_lite'),
      [DashboardSlug.FLOWPAGE_ANALYSIS]:
        hasOperation('view:flowpage_analysis') || hasOperation('view:flowpage_analysis_lite'),
      [DashboardSlug.FLOWCODE_RAW_EVENTS]:
        hasOperation('view:flowcode_raw_events') || hasOperation('view:flowcode_raw_events_lite'),
      [DashboardSlug.FLOWPAGE_RAW_EVENTS]:
        hasOperation('view:flowpage_raw_events') || hasOperation('view:flowpage_raw_events_lite')
    }),
    [hasOperation]
  )

  const canViewAnyReports = useMemo(() => hasOperation('view:flowlytics_reports'), [hasOperation])

  const canViewReport = (reportSlug?: string | string[]): boolean =>
    Boolean(reportSlug && viewableReports[reportSlug as DashboardSlug])

  return {
    viewableReports,
    canViewAnyReports,
    canViewReport
  }
}
